import React, { useState } from 'react';
import { XIcon, DatabaseIcon } from 'lucide-react';
interface AddAssetModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (assetData: any) => void;
}
export const AddAssetModal: React.FC<AddAssetModalProps> = ({
  isOpen,
  onClose,
  onSubmit
}) => {
  const [formData, setFormData] = useState({
    name: '',
    category: 'Server & Komputasi',
    location: 'Pusat/Setuma',
    status: 'Aktif',
    classification: 'Rahasia',
    serialNumber: '',
    manufacturer: '',
    model: '',
    purchaseDate: '',
    value: '',
    notes: ''
  });
  if (!isOpen) return null;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Generate ID based on timestamp for demo
    const newAsset = {
      ...formData,
      id: `AST-${Math.floor(Math.random() * 1000).toString().padStart(3, '0')}`,
      lastUpdate: new Date().toISOString().split('T')[0]
    };
    onSubmit(newAsset);
    // Reset form
    setFormData({
      name: '',
      category: 'Server & Komputasi',
      location: 'Pusat/Setuma',
      status: 'Aktif',
      classification: 'Rahasia',
      serialNumber: '',
      manufacturer: '',
      model: '',
      purchaseDate: '',
      value: '',
      notes: ''
    });
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-3522">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col" data-id="element-3523">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center bg-neutral-light" data-id="element-3524">
          <h2 className="text-xl font-bold text-secondary flex items-center" data-id="element-3525">
            <DatabaseIcon size={20} className="mr-2 text-primary" data-id="element-3526" />
            Tambah Aset Baru
          </h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-gray-200 transition-colors" data-id="element-3527">
            <XIcon size={20} className="text-gray-500" data-id="element-3528" />
          </button>
        </div>

        <div className="overflow-y-auto p-6 flex-grow" data-id="element-3529">
          <form id="add-asset-form" onSubmit={handleSubmit} className="space-y-4" data-id="element-3530">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3531">
              <div className="space-y-1" data-id="element-3532">
                <label className="text-sm font-medium text-gray-700" data-id="element-3533">
                  Nama Aset <span className="text-red-500" data-id="element-3534">*</span>
                </label>
                <input type="text" name="name" required value={formData.name} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Contoh: Server Dell PowerEdge R740" data-id="element-3535" />
              </div>

              <div className="space-y-1" data-id="element-3536">
                <label className="text-sm font-medium text-gray-700" data-id="element-3537">
                  Kategori <span className="text-red-500" data-id="element-3538">*</span>
                </label>
                <select name="category" value={formData.category} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3539">
                  <option value="Server & Komputasi" data-id="element-3540">Server & Komputasi</option>
                  <option value="Jaringan & Komunikasi" data-id="element-3541">
                    Jaringan & Komunikasi
                  </option>
                  <option value="Software & Lisensi" data-id="element-3542">Software & Lisensi</option>
                  <option value="Keamanan Siber" data-id="element-3543">Keamanan Siber</option>
                  <option value="Infrastruktur Digital" data-id="element-3544">
                    Infrastruktur Digital
                  </option>
                </select>
              </div>

              <div className="space-y-1" data-id="element-3545">
                <label className="text-sm font-medium text-gray-700" data-id="element-3546">
                  Lokasi <span className="text-red-500" data-id="element-3547">*</span>
                </label>
                <select name="location" value={formData.location} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3548">
                  <option value="Pusat/Setuma" data-id="element-3549">Pusat/Setuma</option>
                  <option value="BINDA Jawa Timur" data-id="element-3550">BINDA Jawa Timur</option>
                  <option value="STIN" data-id="element-3551">STIN</option>
                  <option value="Deputi I" data-id="element-3552">Deputi I</option>
                  <option value="Deputi II" data-id="element-3553">Deputi II</option>
                  <option value="Deputi III" data-id="element-3554">Deputi III</option>
                  <option value="Deputi IV" data-id="element-3555">Deputi IV</option>
                  <option value="Deputi V" data-id="element-3556">Deputi V</option>
                  <option value="BINDA Sumatera Barat" data-id="element-3557">
                    BINDA Sumatera Barat
                  </option>
                </select>
              </div>

              <div className="space-y-1" data-id="element-3558">
                <label className="text-sm font-medium text-gray-700" data-id="element-3559">
                  Status <span className="text-red-500" data-id="element-3560">*</span>
                </label>
                <select name="status" value={formData.status} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3561">
                  <option value="Aktif" data-id="element-3562">Aktif</option>
                  <option value="Perlu Perawatan" data-id="element-3563">Perlu Perawatan</option>
                  <option value="Akan Habis" data-id="element-3564">Akan Habis</option>
                  <option value="Kritis" data-id="element-3565">Kritis</option>
                </select>
              </div>

              <div className="space-y-1" data-id="element-3566">
                <label className="text-sm font-medium text-gray-700" data-id="element-3567">
                  Klasifikasi <span className="text-red-500" data-id="element-3568">*</span>
                </label>
                <select name="classification" value={formData.classification} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3569">
                  <option value="Sangat Rahasia" data-id="element-3570">Sangat Rahasia</option>
                  <option value="Rahasia" data-id="element-3571">Rahasia</option>
                  <option value="Terbuka" data-id="element-3572">Terbuka</option>
                </select>
              </div>

              <div className="space-y-1" data-id="element-3573">
                <label className="text-sm font-medium text-gray-700" data-id="element-3574">
                  Serial Number
                </label>
                <input type="text" name="serialNumber" value={formData.serialNumber} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="SN-XXXXXXX" data-id="element-3575" />
              </div>

              <div className="space-y-1" data-id="element-3576">
                <label className="text-sm font-medium text-gray-700" data-id="element-3577">
                  Manufacturer
                </label>
                <input type="text" name="manufacturer" value={formData.manufacturer} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Contoh: Dell, Cisco, Fortinet" data-id="element-3578" />
              </div>

              <div className="space-y-1" data-id="element-3579">
                <label className="text-sm font-medium text-gray-700" data-id="element-3580">
                  Model
                </label>
                <input type="text" name="model" value={formData.model} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3581" />
              </div>

              <div className="space-y-1" data-id="element-3582">
                <label className="text-sm font-medium text-gray-700" data-id="element-3583">
                  Tanggal Pembelian
                </label>
                <input type="date" name="purchaseDate" value={formData.purchaseDate} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" data-id="element-3584" />
              </div>

              <div className="space-y-1" data-id="element-3585">
                <label className="text-sm font-medium text-gray-700" data-id="element-3586">
                  Nilai Aset
                </label>
                <div className="relative" data-id="element-3587">
                  <span className="absolute left-3 top-2 text-gray-500 text-sm" data-id="element-3588">
                    Rp
                  </span>
                  <input type="text" name="value" value={formData.value} onChange={handleChange} className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="0" data-id="element-3589" />
                </div>
              </div>
            </div>

            <div className="space-y-1" data-id="element-3590">
              <label className="text-sm font-medium text-gray-700" data-id="element-3591">
                Catatan Tambahan
              </label>
              <textarea name="notes" value={formData.notes} onChange={handleChange} rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-sm" placeholder="Deskripsi kondisi aset atau catatan penting lainnya..." data-id="element-3592"></textarea>
            </div>
          </form>
        </div>

        <div className="p-4 border-t border-gray-200 flex justify-end space-x-2 bg-gray-50" data-id="element-3593">
          <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-100" data-id="element-3594">
            Batal
          </button>
          <button type="submit" form="add-asset-form" className="px-4 py-2 bg-primary text-secondary rounded-md text-sm font-medium hover:bg-opacity-90" data-id="element-3595">
            Simpan Aset
          </button>
        </div>
      </div>
    </div>;
};